<div class="container-fluid">
    <!-- 
    <div class="row capture-screens">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="items">
            
                <div class="slide-img" id="img1"><img src="assets/images/logo.png"></div>
                <div class="slide-img" id="img2"><img src="assets/images/temp-image.jpg"></div>
                <div class="slide-img" id="img3"><img src="assets/images/logo.png"></div>
                <div class="slide-img" id="img4"><img src="assets/images/temp-image.jpg"></div>
                <div class="slide-img" id="img5"><img src="assets/images/logo.png"></div>
                <div class="slide-img" id="img6"><img src="assets/images/temp-image.jpg"></div>
                <div class="slide-img" id="img7"><img src="assets/images/logo.png"></div>
                <div class="slide-img" id="img8"><img src="assets/images/temp-image.jpg"></div>
                <div class="slide-img" id="img9"><img src="assets/images/logo.png"></div>
                <div class="slide-img" id="img10"><img src="assets/images/temp-image.jpg"></div>
                <div class="slide-img" id="img11"><img src="assets/images/logo.png"></div>

            </div>
            <a class="btn btn-prev" (click)="slideImage('prev')"><i class="fa fa-angle-left"></i></a>
            <a class="btn btn-next" (click)="slideImage('next')"><i class="fa fa-angle-right"></i></a>
        </div>
    </div> -->
    <div class="row details-section mb-2">
        <div class="col-md-6 col-sm-6 col-6">
            <div class="applicant-details">
                <h4 class="title"><b>Client:</b> {{client}}</h4>
            </div>
        </div>
        <div class="col-md-6 col-sm-6 col-6" style="text-align:right;">
            <div class="applicant-details">
                <h4 class="title" style="text-align:right;"><b>Activity:</b> {{activity}}</h4>
            </div>
        </div>
    </div>
    <div class="row details-section mb-2">
        <div class="col-md-6 col-sm-6 col-6">
            <div class="applicant-details">
                <h4 class="title"><b>latitude:</b> {{webSocketSrvc['latitude']}}</h4>
            </div>
        </div>
        <div class="col-md-6 col-sm-6 col-6" style="text-align:right;">
            <div class="applicant-details">
                <h4 class="title" style="text-align:right;"><b>longitude:</b> {{webSocketSrvc['longitude']}}</h4>
            </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12">
            <div class="applicant-details">
                <h4 class="title"><b>Address:</b> {{address}}</h4>
            </div>
        </div>
    </div>
    <div class="row details-section">

        <div class="col-md-12" style="text-align:left;">
            <span class="mobile-number">
                <form #videoLinkForm="ngForm">
                    <div class="row mx-0 mb-2">
                        <div class="col-md-5 col-sm-5 col-5 px-1">
                            <input type="email" name="email" class="form-control" [(ngModel)]="email"
                                [disabled]="isSMSSend" placeholder="Enter email ID"
                                (keyup)="isSMSSend=false || showErrorMsg=false" />
                        </div>
                        <div class="col-md-5 col-sm-5 col-5 px-1">
                            <input type="text" maxlength="10" name="text" class="form-control" [(ngModel)]="mobileNo"
                                style="width:100%;" placeholder="Enter Mobile No" [disabled]="isSMSSend"
                                (keyup)="isSMSSend=false || showErrorMsg=false" />
                        </div>
                        <div class="col-md-2 col-sm-2 col-2 px-1">
                            <button name="" class="btn btn-sm btn-shadow send-sms" [disabled]="isSMSSend"
                                (click)="sendSMS()">
                                <i class="fa fa-paper-plane-o" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                </form>

                <p *ngIf="showErrorMsg" style="text-align:center; margin:0px; color:#ee3d3d; line-height: 18px;"><small
                        style="font-size:10px;">{{errorMsg}}</small></p>
                <!-- <p *ngIf="smsStatus" style="text-align:center; margin:0px; color:#478f11; line-height: 18px;"><small
                        style="font-size:10px;">{{smsStatus}}</small></p> -->
                <p *ngIf="showSuccesMsg" style="text-align:center; margin:0px; color:#478f11; line-height: 18px;">
                    <small style="font-size:10px;" [innerHTML]="emailMsg"></small></p>
            </span>
        </div>
    </div>

    <div class="row" style="display:flex; height:75vh;">
        <div class="col-md-12 col-md-12 col-sm-12 video-calling"
            style="display: flex;flex:1; flex-direction: column; height:100%;">
            <div class="card">
                <div class="card-body" style="position: relative;">

                    <div class="loading-buttons"
                        style="display: none; cursor: not-allowed !important; pointer-events: all !important; position: absolute;background: rgba(0, 0, 0, 0.2);border-radius: 12px;"
                        id="loader-div1">
                        <span class="loading-icon">
                            <img src="assets/images/loader/spinner.gif" />
                        </span>
                    </div>

                    <div class="live-recording on" *ngIf="isRecordingStarted && timeIntervalStr">
                        <span class="light">
                            <i class="fa fa-circle blinking" aria-hidden="true"></i>
                        </span>
                        <span class="recording-timer">{{timeIntervalStr}} {{startTime | date:'dd-MMM-yyyy
                            HH:mm'}}</span>
                    </div>

                    <div class="video-player" id="me" style="display: none;"></div>

                    <div class="video-player iframe-video" id="remote-container" #remoteVideo></div>

                    <div class="video-buttons text-center">
                        <ul class="player-buttons">
                            <li *ngIf="isRecordingStarted">
                                <button *ngIf="!isMute" type="button" class="btn btn-shadow capture"
                                    style="color: #327103;" (click)="muteTheCallAudio()">
                                    <i class="fa fa-volume-up" aria-hidden="true"></i>
                                </button>
                                <button *ngIf="isMute" type="button" class="btn btn-shadow capture"
                                    style="color: #327103;" (click)="unmuteTheCallAudio()">
                                    <i class="fa fa-volume-off" aria-hidden="true"></i>
                                </button>
                            </li>
                            <li *ngIf="isRecordingStarted">
                                <button type="button" class="btn btn-shadow capture" style="color: #327103;"
                                    (click)="captureVideImage()">
                                    <i class="fa fa-picture-o" aria-hidden="true"></i>
                                </button>
                            </li>
                            <!-- <li *ngIf="isRecordingStarted">
                                <button type="button" (click)="switchDevice()"
                                    class="btn btn-shadow active">
                                    <i class="fa fa-camera" aria-hidden="true"></i>
                                </button>
                            </li> -->
                            <li *ngIf="isRecordingStarted">
                                <!-- (click)="showConfirmationModal=true" -->
                                <button type="button" (click)="closeMeeting()" class="btn btn-shadow play-stop active">
                                    <i class="fa fa-phone" aria-hidden="true"
                                        style="transform-origin: center;transform: rotate(137deg);"></i>
                                </button>
                            </li>
                            <!-- <li *ngIf="!isRecordingStarted">
                                <button type="button" (click)="startVideoRecording()" class="btn btn-shadow on-recording">
                                    <i class="fa fa-dot-circle-o" aria-hidden="true"></i>
                                </button>
                            </li> -->
                            <!-- <li>
                                <button type="button"
                                    (click)="requestAgoraToStopRecordingsToAllowFilesTbeWrittenOnS3()" class="btn btn-shadow on-recording">
                                    <i class="fa fa-dot-circle-o" aria-hidden="true"></i>
                                </button>
                            </li> -->

                        </ul>
                    </div>

                </div>

                <!-- <button type="button" (click)="downloadJson()"></button> -->

                <div class="card-footer" *ngIf="capturedImages.length">
                    <div class="row capture-screens" style="top:-15px;">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <!-- First selector is for image deletion -->
                            <ng-image-slider id="deleteImageSelector" [images]="capturedImagesForDeletion"
                                (imageClick)="deleteCarousalImage($event)"
                                [imageSize]="{width: '50px', height: '25px', space: 4}" [showArrow]="false"
                                [imagePopup]="false" #navForImgDele></ng-image-slider>
                            <!-- End image deletio selector -->
                            <ng-image-slider id="normalImageSelector" [images]="capturedImages"
                                [imageSize]="{width: '50px', height: '50px', space: 4}"
                                (arrowClick)="arrowClick($event)" #nav></ng-image-slider>
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center mb-10" *ngIf="isRecordingStarted && false">

                    <div class="col-5">
                        <label for="deviceId">
                            Video quality:

                            <select name="deviceId" id="deviceId" [(ngModel)]="qualityMode"
                                (ngModelChange)="changeVideoQuality($event)">
                                <option *ngFor="let mode of ['balanced','motion','detail']" [value]="mode">{{mode |
                                    uppercase}}</option>
                            </select>
                        </label>
                    </div>

                </div>
            </div>
        </div>
    </div>





    <!--error message modal-->
    <!-- Modal -->
    <div class="modal error-message-modal" id="errormsgModal" style="display: none;">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="errormodaltitle"></h5>
                    <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                             <span aria-hidden="true">&times;</span>
                         </button> -->
                </div>
                <div class="modal-body" id="errormodalbody">
                    <p id="errormodalmessage"></p>
                </div>
                <div class="modal-footer">
                    <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
                    <button type="button" (click)="closeErrorModal()" class="btn btn-sm btn-primary btn-sm"><i
                            class="fa fa-check-circle-o" aria-hidden="true"></i> Ok</button>
                </div>
            </div>
        </div>
    </div>

    <!--message modal-->
    <!-- Modal -->
    <div class="modal error-message-modal" id="confirmationModal"
        [ngStyle]="{'display': showConfirmationModal?'block':'none'}">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="errormodaltitle">Close Video Call </h5>
                    <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button> -->
                </div>
                <div class="modal-body" id="errormodalbody">
                    <p id="errormodalmessage" [innerHTML]="warningMsg"></p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary btn-sm"
                        (click)="terminatedByRemoteUser?leavechannel():showConfirmationModal=false"
                        data-dismiss="modal"><i class="fa fa-times-circle-o" aria-hidden="true"></i> No</button>
                    <button type="button" (click)="confirmCloseButton()" class="btn btn-primary btn-sm"><i
                            class="fa fa-check-circle-o" aria-hidden="true"></i> Yes</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal error-message-modal" id="confirmationModal1"
        [ngStyle]="{'display': showConfirmationModalForDeleteImage?'block':'none'}">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="errormodaltitle">Delete the image</h5>
                    <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button> -->
                </div>
                <div class="modal-body" id="errormodalbody">
                    <p id="errormodalmessage">Are you sure?</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary btn-sm"
                        (click)="showConfirmationModalForDeleteImage=false" data-dismiss="modal"><i
                            class="fa fa-times-circle-o" aria-hidden="true"></i> No</button>
                    <button type="button" (click)="confirmDeleteImage()" class="btn btn-primary btn-sm"><i
                            class="fa fa-check-circle-o" aria-hidden="true"></i> Yes</button>
                </div>
            </div>
        </div>
    </div>

    <!--message modal-->
    <!-- Modal -->
    <div class="modal error-message-modal" id="confirmationModalErr"
        [ngStyle]="{'display': commonMessagesModal['show']?'block':'none'}">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="errormodaltitle">{{commonMessagesModal['title']}}</h5>
                    <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button> -->
                </div>
                <div class="modal-body" id="errormodalbody">
                    <p id="errormodalmessage">{{commonMessagesModal['message']}}</p>
                </div>
                <div class="modal-footer">
                    <!-- <button type="button" class="btn btn-secondary btn-sm" (click)="commonMessagesModal['show']=false"
                        data-dismiss="modal">No</button> -->
                    <button type="button" (click)="commonMessagesModal['show']=false"
                        class="btn btn-primary btn-sm">{{commonMessagesModal['okBtnText']}}</button>
                </div>
            </div>
        </div>
    </div>


    <span *ngIf="toastMsg['show']">

        <div class="toast-message" [ngClass]="toastMsg['isSuccess']?'toast--green':'toast--red'"
            [ngStyle]="{bottom:(toastMsg['show']?'18%':'-100%')}">
            <div class="toast__icon">
                <!-- <i class="fa fa-check" aria-hidden="true"></i> -->
                <i class="fa fa-times" aria-hidden="true"></i>
            </div>
            <div class="toast__content">
                <!-- <p class="toast__type">Success</p> -->
                <p class="toast__message">{{toastMsg['msg']}}</p>
            </div>
            <!-- <div class="message"></div> -->
        </div>
    </span>
    <!-----------button with hover tooltip------------->

    <!-- <div class="my-3 text-center">
    <button class="btn btn-primary tootltip mx-1" data-title="Look, a tooltip!">tooltip</button>
  </div> -->



    <!--Loading Modal -->
    <div class="modal error-message-modal" id="confirmationModal"
        [ngStyle]="{'display': showLoadingModal?'block':'none'}">
        <div class="modal-dialog">
            <div class="modal-content">
                <!-- <div class="modal-header">
                 
              </div> -->
                <div class="modal-body" id="errormodalbody">
                    <img class="loaging-gif" src="../../assets/images/loader/spinner.gif" />
                    <h5 class="modal-title" *ngIf="loadingsubTitleModalMsg" style="color:#209a28;">{{loadingsubTitleModalMsg}}</h5>
                    <h5 class="modal-title" id="errormodaltitleLoading">{{loadingTitleModalMsg}} </h5>
                    <div class="bracket-view">
                        <p id="errormodalmessage" [innerHTML]="loadingBodyModalMsg"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>